export default "__VITE_ASSET__Dl$AJwnF__"